import React from 'react';
import { Link } from 'react-router-dom';
import efcalogo from "../../assests/efca_logo.jpg";

function Financials() {
  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#333",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "0 1.5rem 4rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            marginTop: "1.5rem",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            color: "#f4813b",
            fontSize: "3rem",
            margin: "1rem 0 0.3rem",
          }}
        >
          Financials
        </h1>

        {/* Orange dots */}
        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "2.5rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <span
              key={i}
              style={{
                width: 4,
                height: 4,
                borderRadius: "50%",
                background: "#f4813b",
              }}
            />
          ))}
        </div>

        {/* Content */}
        <div
          style={{
            display: "flex",
            gap: "3rem",
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          {/* Left */}
          <div
            style={{
              flex: "0 0 280px",
              textAlign: "center",
            }}
          >
            <img
              src={efcalogo}
              alt="ECFA Accredited"
              style={{
                width: "220px",
                maxWidth: "100%",
              }}
            />
          </div>

          {/* Right */}
          <div
            style={{
              flex: 1,
              minWidth: "280px",
            }}
          >
            <p
              style={{
                fontSize: "18px",
                lineHeight: 1.8,
                marginBottom: "2rem",
              }}
            >
              <em>Christ For India</em> has been a member in good standing of
              ECFA since 1994.
            </p>

            <h2
              style={{
                fontSize: "28px",
                marginBottom: "1rem",
                color: "#222",
              }}
            >
              What is ECFA ?
            </h2>

            <p
              style={{
                fontSize: "18px",
                lineHeight: 1.8,
                marginBottom: "1rem",
              }}
            >
              Evangelical Council for Financial Accountability
            </p>

            <p
              style={{
                fontSize: "18px",
                lineHeight: 1.9,
                color: "#444",
              }}
            >
              ECFA provides accreditation to leading Christian nonprofit
              organizations that faithfully demonstrate compliance with
              established standards for financial accountability,
              transparency, fundraising, and board governance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Financials;
